// extracted by mini-css-extract-plugin
module.exports = {"EmoteTags":"EmoteTags_EmoteTags__3AzDb"};